<template>
    <div class="DiscountCoupon padding-20 bgc box-shadow">
        <!-- <keep-alive include="LotteryList"> -->
            <router-view></router-view>
        <!-- </keep-alive> -->
    </div>
</template>

<script>
    export default {
        name: 'DiscountCoupon',
        data() {
            return {}
        },
        mounted() {
        },
        methods: {},
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss">
    .DiscountCoupon {
        min-width: 1100px;
        font-family: PingFangSC-Regular, PingFang SC;
    }
</style>